import { render, staticRenderFns } from "./ManualStockRecord.vue?vue&type=template&id=1ba63d20&scoped=true"
import script from "./ManualStockRecord.vue?vue&type=script&lang=js"
export * from "./ManualStockRecord.vue?vue&type=script&lang=js"
import style0 from "./ManualStockRecord.vue?vue&type=style&index=0&id=1ba63d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba63d20",
  null
  
)

export default component.exports